module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "fm3"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fmhT"
  }, [_c('b', [_vm._v("Alignment to National Council of Teachers of Mathematics Standards")])]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_vm._v("The following table indicates the NCTM Standards addressed by the projects of this book. Checks indicate the specific standards with which each project aligns. For some projects, skills will vary depending on the material students create for the project.")]), _vm._v(" "), _c('div', {
    staticClass: "centerAligned"
  }, [_c('img', {
    staticClass: "imgepub",
    attrs: {
      "alt": "002",
      "src": "musc_9781118040942_oeb_002_r1.gif"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "centerAligned"
  }, [_c('img', {
    staticClass: "imgepub",
    attrs: {
      "alt": "003",
      "src": "musc_9781118040942_oeb_003_r1.gif"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6139f9e9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/musc_9781118040942_oeb_fm3_r1.vue
// module id = 81
// module chunks = 0